import React from 'react';

function Dropdown({ options, onChange, value, label }) {
	return (
		<div className="slds-form-element">
			<label className="slds-form-element__label">{label}</label>
			<select className="slds-input slds-combobox__input" value={value} onChange={(e) => onChange(e.target.value)}>
				{options.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</select>
		</div>
	);
}

export default Dropdown;